export default "__VITE_ASSET__C8wOqj7a__"